<!-- 积分抽奖活动奖品配置 -->
<template>
  <div class='content'>
    <el-form ref="form" label-width="auto" align="left" :inline="true">
      <el-form-item label="状态：">
        <el-select v-model="params.status">
          <el-option value="" label="全部"></el-option>
          <el-option :value="0" label="启用"></el-option>
          <el-option :value="1" label="禁用"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="getTableList()">搜索</el-button>
        <el-button size="small" @click="resetParams();getTableList();">重置</el-button>
        <!-- <el-button size="small" type="primary">导出</el-button> -->
      </el-form-item>
    </el-form>

    <div>抽奖活动名称：{{ activity.activityName }} &nbsp; <el-button size="small" type="primary" @click="resetFormList();prize.visible=true">新增奖品</el-button></div>
    <el-table
      :data="tableData"
      class="mt-20"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}">
      <!-- show-overflow-tooltip -->
      <el-table-column label="奖品名称" prop="prizeName"></el-table-column>
      <el-table-column label="数值" prop="prizeValue"></el-table-column>
      <el-table-column label="展示排序" prop="prizeOrder">
        <template slot-scope="scope">
          <span v-if="!scope.row.prizeOrderShow">{{ scope.row.prizeOrder }}</span>
          <el-button v-if="!scope.row.prizeOrderShow" type="text" size="small" @click="editOrder(scope.row.prizeId)">编辑</el-button>
          <el-input style="width: 60px;" v-if="scope.row.prizeOrderShow" @change="confirmOrder" v-model="prizeOrderForm.order"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="概率" prop="prizeProbability">
        <template slot-scope="scope">
          <span v-if="!scope.row.prizeProbabilityShow">{{ scope.row.prizeProbability }}</span>
          <el-button v-if="!scope.row.prizeProbabilityShow" type="text" size="small" @click="editProbability(scope.row.prizeId)">编辑</el-button>
          <el-input style="width: 60px;" v-if="scope.row.prizeProbabilityShow" @change="confirmProbability" v-model="prizeProbabilityForm.prob"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="已抽取数量" prop="usedStock">
        <template slot-scope="scope">
          <span v-if="!scope.row.usedStockShow">{{ scope.row.usedStock }}</span>
          <!-- <el-button v-if="!scope.row.usedStockShow" type="text" size="small" @click="editUsedStock(scope.row.prizeId)">编辑</el-button>
          <el-input style="width: 60px;" v-if="scope.row.usedStockShow" @change="confirmUsedStock" v-model="usedStockForm.extractNum"></el-input> -->
        </template>
      </el-table-column>
      <el-table-column label="奖品剩余数量" prop="prizeStock"></el-table-column>
      <el-table-column label="每日限额" prop="perDayLimit">
        <template slot-scope="scope">
          <span>{{ Number(scope.row.perDayLimit) > 0 ? scope.row.perDayLimit : '不限' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="单账号总限额" prop="totalLimit">
        <template slot-scope="scope">
          <span>{{ Number(scope.row.totalLimit) > 0 ? scope.row.totalLimit : '不限' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="isDeleted">
        <template slot-scope="scope">
          <span v-if="scope.row.isDeleted == 0">启用</span>
          <span v-if="scope.row.isDeleted == 1">禁用</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="updateStatus(scope.row)">{{ scope.row.isDeleted==1?'启用':'禁用' }}</el-button>
          <el-button
            type="text"
            size="small"
            v-if="scope.row.prizeType == 1"
            @click="openInventory(scope.row)">同步库存</el-button>
          <el-button
            type="text"
            size="small"
            @click="openWarning(scope.row)">库存预警</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-row class="mt-15 mr-20 text-right" v-if="total > 0">
      <el-pagination
        small
        layout="total,prev,pager,next,jumper"
        :page-size="params.pageSize"
        :total="total"
        :current-page.sync="params.pageNum"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-row>

    <!-- 新增/编辑 -->
    <el-dialog :title="prize.title" width="800px" top="20px" :visible.sync="prize.visible">
      <div class="prize_content">
        <el-table
          :data="formList"
          :header-cell-style="{'text-align':'center'}"
          :cell-style="{'text-align':'center'}">
          <el-table-column label="商品名称" prop="productId" width="200px">
            <template slot-scope="scope">
              <el-select style="width: 180px" v-model="scope.row.productId" filterable clearable>
                <el-option v-for="i in productList" :key="i.productId" :value="i.productId" :label="i.productName"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="奖品名称" prop="prizeName"  width="200px">
            <template slot-scope="scope">
              <el-input style="width: 180px" v-model="scope.row.prizeName"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="展示排序" prop="prizeOrder" width="100px">
            <template slot-scope="scope">
              <el-input style="width: 60px" v-model="scope.row.prizeOrder"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="概率" prop="prizeProbability" width="100px">
            <template slot-scope="scope">
              <div style="display: flex; align-items: center;justify-content: center;">
                <el-input style="width: 60px;" v-model="scope.row.prizeProbability" @input="prizeProbabilityFilter"></el-input>%
              </div>
            </template>
          </el-table-column>
          <el-table-column label="数量" prop="prizeStock" width="100px">
            <template slot-scope="scope">
              <el-input style="width: 60px" v-model="scope.row.prizeStock"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="每日限额" prop="perDayLimit" width="140px">
            <template slot-scope="scope">
              <el-input style="width: 100px" v-model="scope.row.perDayLimit" placeholder="不填或0为不限"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="单账号总限额" prop="totalLimit" width="130px">
            <template slot-scope="scope">
              <el-input style="width: 100px" v-model="scope.row.totalLimit" placeholder="不填或0为不限"></el-input>
            </template>
          </el-table-column>
           <el-table-column label="操作" width="60px">
            <template slot-scope="scope">
              <el-button size="small" type="primary" @click="deleteProduct(scope.row.productId)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="display: flex; align-items: center;justify-content: center;margin-top: 10px;">
          总计概率：{{ prizeProbabilityNum }}% &nbsp;
          <el-button
            size="small"
            type="primary"
            @click="formList.push({
              productId:'',
              activityId:'',
              prizeName:'',
              prizeOrder:'',
              prizeProbability: '',
              prizeStock:'',
              perDayLimit: 0,
              totalLimit: 0});prizeProbabilityFilter()">
            添加奖品</el-button>
        </div>
      </div>
      <el-row class="text-right mt-20">
        <el-button @click="resetFormList();prize.visible=false;prize.title='';">取消</el-button>
        <el-button type="primary" :loading="buttonLoading" @click="confirm()">确定</el-button>
      </el-row>
    </el-dialog>

    <!-- 库存预警 -->
    <el-dialog :title="warning.title" top="20px" :visible.sync="warning.visible">
      <el-form :model="warningForm" ref="warningForm" :rules="warningRules" label-width="auto">
        <el-form-item label="预警商品：">{{ warningProductName }}</el-form-item>
        <el-form-item label="预警门槛：" prop="stockWarn">
          <el-input type="text" v-model="warningForm.stockWarn" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="预警手机号：" prop="warnMobile">
          <el-input type="text" v-model="warningForm.warnMobile" placeholder="请输入预警手机号用 ,分割"></el-input>
        </el-form-item>
      </el-form>
      <el-row class="text-right mt-20">
        <el-button @click="resetWarningForm();warning.title='';warning.visible=false">取消</el-button>
        <el-button type="primary" :loading="buttonLoading" @click="confirmWarning()">确定</el-button>
      </el-row>
    </el-dialog>

    <!-- 同步库存 -->
    <el-dialog title="同步库存" top="20px" :visible.sync="visibleInventory">
      <el-form label-width="auto">
        <el-form-item label="商品名称：">{{ warningProductName }}</el-form-item>
        <el-form-item label="剩余库存：">{{ inventoryNum }}</el-form-item>
      </el-form>
      <el-table
        :data="inventoryData"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}">
        <el-table-column label="序号" prop="stockId"></el-table-column>
        <el-table-column label="cdKey" prop="cdkeyCode"></el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-row class="mt-15 mr-20 text-right" v-if="total > 0">
        <el-pagination
          :page-size="inventoryParams.pageSize"
          :total="inventoryTotal"
          :current-page.sync="inventoryParams.pageNum"
          :page-sizes="[10 ,20 , 30, 40, 50]"
          @size-change="handleSizeChangeInventory"
          @current-change="handleCurrentChangeInventory">
        </el-pagination>
      </el-row>
      <el-row class="text-center mt-20">
        <el-button type="primary" @click="visibleInventory=false;withdrawVisible=true;">库存提取</el-button>
        <el-button type="primary" @click="visibleInventory=false;dialogVisibleBatch=true;formBatch.file=''">库存同步</el-button>
      </el-row>
    </el-dialog>

    <!-- 提取 -->
    <el-dialog title="提取" top="20px" width="400px" :visible.sync="withdrawVisible">
      <el-form :model="withdrawForm" ref="withdrawForm" :rules="withdrawRules" label-width="auto">
        <el-form-item label="提取数量：" prop="extractNum">
          <el-input type="text" v-model="withdrawForm.extractNum" placeholder="请输入提取数量"></el-input>
        </el-form-item>
      </el-form>
      <el-row class="text-right mt-20">
        <el-button @click="resetWithdrawForm();withdrawVisible=false">取消</el-button>
        <el-button type="primary" :loading="buttonLoading" @click="confirmWithdraw()">确定</el-button>
      </el-row>
    </el-dialog>

    <el-dialog title="库存同步" top="20px" width="500px" :visible.sync="dialogVisibleBatch">
      <el-form :model="formBatch" ref="formBatch" label-width="auto">
        <el-form-item label="上传文件：" required="">
          <el-upload
            class="upload-demo"
             action="" :http-request="importExcel" :show-file-list="false">
            <el-button v-if="!formBatch.file" size="small" type="primary">点击上传</el-button>
            <span v-if="formBatch.file">{{ formBatch.file.name }}</span>
            <el-button v-if="formBatch.file" size="small" type="primary" style="margin-left: 5px;">重新上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div style="font-size: 12px;padding-left: 80px;color: #4200ff;cursor: pointer;" @click="exportExcel">下载模板</div>
      <el-row class="text-right mt-20">
        <el-button @click="formBatch.file='';dialogVisibleBatch=false">取消</el-button>
        <el-button type="primary" :loading="buttonLoading" @click="confirmBatch()">确定</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';

  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    //ComponentName和文件名保持一致
    name:'lotteryActivityTaskPrizes',
    data() {
      //这里存放数据
      return {
        activity:{
          activityId: '',
          activityName:"",
        },
        params: {
          activityId: '',
          status: '',
          pageNum: 1,
          pageSize: 10,
        },
        tableData: [],
        total: 0,
        prizeOrderForm: {
          activityId: '',
          prizeId: '',
          order: ''
        },
        prizeProbabilityForm: {
          activityId: '',
          prizeId: '',
          prob:''
        },
        usedStockForm: {
          activityId: '',
          prizeId: '',
          extractNum:''
        },
        prize:{
          title: '新增',
          visible: false,
        },
        buttonLoading:false, //按钮加载状态，防止重复提交
        dialogVisible:false, //弹窗显示隐藏状态
        productList:[],
        formList:[
          {
           productId:'',
           activityId:'',
           prizeName:'',
           prizeOrder:'',
           prizeProbability: '',
           prizeStock:'',
           perDayLimit: 0,
           totalLimit: 0
          }
        ],
        prizeProbabilityNum: 0,

        warning:{
          title:'库存预警',
          visible:false,
        },
        warningForm: {
          prizeId: '',
          stockWarn:'',
          warnMobile:''
        },
        warningRules: {
          stockWarn: [{ required: true, message: "请输入预警门槛", trigger: "blur" }],
          warnMobile: [{ required: true, message: "请输入预警手机号", trigger: "blur" }]
        },
        warningProductName: '',
        inventoryNum: '',
        visibleInventory: false,
        inventoryParams: {
          pageNum: 1,
          pageSize: 10,
          prizeId: '',
          isPage: true
        },
        inventoryData: [],
        inventoryTotal: 0,
        withdrawVisible: false,
        withdrawForm: {
          prizeId:'',
          extractNum:''
        },
        withdrawRules:{
          extractNum:[{ required: true, message: "请输入提取数量", trigger: "blur" }]
        },
        dialogVisibleBatch: false,
        formBatch: {
          file:{},
          prizeId: '',
          productId: '',
          activityId: ''
        },
        rowData:{}
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      /**获取列表数据 */
      getTableList(){
        this.params.activityId = this.activity.activityId;
        this.ajax.fetch({
          url: this.apis.lotteryActivityTaskPrizes.get,
          disableLoading: true,
          method: 'post',
          param: this.params,
          successFunc: res=>{
            this.total = res.total;
            this.tableData = res.result;
            this.tableData.forEach(i => {
              this.$set(i, 'prizeOrderShow', false);
              this.$set(i, 'prizeProbabilityShow', false);
              this.$set(i, 'usedStockShow', false);
            })
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      importExcel(file) {
        let index1 = file.file.name.lastIndexOf(".");
        let index2 = file.file.name.length;
        let postf = file.file.name.substring(index1, index2);//后缀名
        if (postf.indexOf('xlsx') === -1 && postf.indexOf('xls') === -1) {
          this.toast.showWarning('只能上传excel文件');
          return;
        }
        this.formBatch.file = file.file;
      },
      confirmBatch(){
        if(!this.formBatch.file) return this.$message.error('请选择文件');
        this.formBatch.activityId = this.rowData.activityId;
        this.formBatch.prizeId = this.rowData.prizeId;
        this.formBatch.productId = this.rowData.productId;
        this.ajax.upload({
          url: this.apis.lotteryActivityTaskPrizes.import,
          param: this.formBatch,
          successFunc: res => {
            this.$message.success('同步成功');
            this.dialogVisibleBatch = false;
            this.formBatch.file = '';
            this.getTableList();
          },
          errorFunc: res => {
            this.$message.error(res.info);
          }
        })
      },
      exportExcel(){
        this.ajax.downLoad(this.apis.netBarAccountManage.downLoad , {templateName:'cdKey'});
      },
      confirmWithdraw(){
        this.withdrawForm.prizeId = this.inventoryParams.prizeId;
        this.$refs.withdrawForm.validate(valid => {
          if (valid) {
            this.ajax.fetch({
              url: this.apis.lotteryActivityTaskPrizes.extractCdKey,
              disableLoading: true,
              method: 'post',
              param: this.withdrawForm,
              successFunc: res=>{
                this.$message.success('提取成功!');
                this.withdrawVisible = false;
                this.resetWithdrawForm();
                this.tableData();
              },
              errorFunc: err=>{
                this.$message.error(err.info);
              }
            });
          } else {
            return false;
          }
        });
      },
      resetWithdrawForm(){
        this.withdrawForm = {
          prizeId:'',
          extractNum:''
        };
      },
      openInventory(row){
        this.rowData = row;
        this.inventoryNum = row.prizeStock;
        this.warningProductName = row.prizeName;
        this.inventoryParams.prizeId = row.prizeId;
        this.inventoryParams.pageNum = 1;
        this.inventoryParams.pageSize = 5;
        this.getSyncStockCdKeyList();
      },
      getSyncStockCdKeyList(){
        this.ajax.fetch({
          url: this.apis.lotteryActivityTaskPrizes.getSyncStockCdKeyList,
          disableLoading: true,
          method: 'post',
          param: this.inventoryParams,
          successFunc: res=>{
            this.inventoryTotal = res.total;
            this.inventoryData = res.result;
            this.visibleInventory = true;
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      openWarning(row){
        this.warning.title = '库存预警';
        this.warning.visible = true;
        this.warningForm.prizeId = row.prizeId;
        this.warningProductName = row.prizeName;
      },
      confirmWarning(){
        this.$refs.warningForm.validate(valid => {
          if (valid) {
            this.confirmWarningFunc();
          } else {
            return false;
          }
        });
      },
      confirmWarningFunc(){
        this.ajax.fetch({
          url: this.apis.lotteryActivityTaskPrizes.stockWarn,
          disableLoading: true,
          method: 'post',
          param: this.warningForm,
          successFunc: res=>{
            this.$message.success('预警成功!');
            this.warning.visible = false;
            this.getTableList();
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      resetWarningForm(){
        this.warningForm = {
          prizeId: '',
          stockWarn:'',
          warnMobile:''
        }
      },
      // ==================================================================================
      updateStatus(row){
        let obj ={
          activityId: this.params.activityId,
          prizeId: row.prizeId,
          status: row.isDeleted == 1 ? 0 : 1
        }
        let txt = row.isDeleted==1?'启用':'禁用';
        this.$confirm(`确定${txt}该项?`, `确认${txt}`, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.ajax.fetch({
            url: this.apis.lotteryActivityTaskPrizes.updateStatus,
            disableLoading: true,
            method: 'post',
            param: obj,
            successFunc: res=>{
              this.$message({
                type: 'success',
                message: `${txt}成功!`
              });
              this.getTableList();
            },
            errorFunc: err=>{
              console.log(err);
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: `已取消${txt}`
          });
        });
      },
      editOrder(prizeId){
        this.tableData.filter(i => i.prizeId == prizeId)[0].prizeOrderShow = true;
        this.prizeOrderForm.activityId = this.params.activityId;
        this.prizeOrderForm.prizeId = prizeId;
        this.prizeOrderForm.order = this.tableData.filter(i => i.prizeId == prizeId)[0].prizeOrder;
      },
      confirmOrder(){
        this.ajax.fetch({
          url: this.apis.lotteryActivityTaskPrizes.updateOrder,
          disableLoading: true,
          method: 'post',
          param: this.prizeOrderForm,
          successFunc: res=>{
            this.getTableList();
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      editProbability(prizeId){
        this.tableData.filter(i => i.prizeId == prizeId)[0].prizeProbabilityShow = true;
        this.prizeProbabilityForm.activityId = this.params.activityId;
        this.prizeProbabilityForm.prizeId = prizeId;
        this.prizeProbabilityForm.prob = this.tableData.filter(i => i.prizeId == prizeId)[0].prizeProbability;
      },
      confirmProbability(){
        this.ajax.fetch({
          url: this.apis.lotteryActivityTaskPrizes.updateProbability,
          disableLoading: true,
          method: 'post',
          param: this.prizeProbabilityForm,
          successFunc: res=>{
            this.getTableList();
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      editUsedStock(prizeId){
        this.tableData.filter(i => i.prizeId == prizeId)[0].usedStockShow = true;
        this.usedStockForm.activityId = this.params.activityId;
        this.usedStockForm.prizeId = prizeId;
        this.usedStockForm.extractNum = this.tableData.filter(i => i.prizeId == prizeId)[0].usedStock;
      },
      confirmUsedStock(){
        this.usedStockForm.extractNum = this.usedStockForm.extractNum;
        this.ajax.fetch({
          url: this.apis.lotteryActivityTaskPrizes.updateUsedStock,
          disableLoading: true,
          method: 'post',
          param: this.usedStockForm,
          successFunc: res=>{
            this.getTableList();
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      deleteProduct(productId){
        this.formList = this.formList.filter(i => i.productId != productId);
      },
      normalizeLimitValue(value){
        if (value === '' || value === null || value === undefined) {
          return 0;
        }
        const text = String(value).trim();
        if (!text) {
          return 0;
        }
        if (!/^\d+$/.test(text)) {
          return null;
        }
        return Number(text);
      },
      confirm(){
        for (let i = 0; i < this.formList.length; i++) {
          const item = this.formList[i];
          const perDayLimit = this.normalizeLimitValue(item.perDayLimit);
          const totalLimit = this.normalizeLimitValue(item.totalLimit);
          if (perDayLimit === null) {
            return this.$message.error('每日限额必须为非负整数');
          }
          if (totalLimit === null) {
            return this.$message.error('单账号总限额必须为非负整数');
          }
          item.perDayLimit = perDayLimit;
          item.totalLimit = totalLimit;
        }
        this.formList.forEach(i => {
          i.activityId = this.params.activityId;
        });
        this.ajax.fetch({
          url: this.apis.lotteryActivityTaskPrizes.add,
          disableLoading: true,
          method: 'post',
          contentType: 'application/json',
          transferJson: true,
          param: this.formList,
          successFunc: res=>{
            this.prize.visible = false;
            this.prize.title = '';
            this.getTableList();
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      prizeProbabilityFilter(){
        this.prizeProbabilityNum = 0;
        this.formList.forEach(i => {
          this.prizeProbabilityNum += Number(i.prizeProbability);
        })
      },
      getProductList(){
        this.ajax.fetch({
          url: this.apis.goodsManage.get,
          disableLoading: true,
          method: 'post',
          param: {
            productName: '',
            productType: '',
            pageNum: 1,
            pageSize: 999
          },
          successFunc: res=>{
            this.productList = res.result;
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      resetParams(){
        this.params = {
          activityId: '',
          status: '',
          pageNum: 1,
          pageSize: 10,
        };
      },
      resetFormList(){
        this.formList = [
          {
           productId:'',
           activityId:'',
           prizeName:'',
           prizeOrder:'',
           prizeProbability: '',
           prizeStock:'',
           perDayLimit: 0,
           totalLimit: 0
          }
        ];
        this.prizeProbabilityFilter();
      },
      handleSizeChange(page) {
        this.params.pageSize = page;
        this.getTableList();
      },
      handleCurrentChange(val){
        this.params.pageNum = val;
        this.getTableList();
      },
      handleSizeChangeInventory(page) {
        this.inventoryParams.pageSize = page;
        this.getSyncStockCdKeyList();
      },
      handleCurrentChangeInventory(val){
        this.inventoryParams.pageNum = val;
        this.getSyncStockCdKeyList();
      },
    },
    beforeCreate() {}, //生命周期 - 创建之前
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    beforeMount() {}, //生命周期 - 挂载之前
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.activity.activityId = this.$route.query.activityId;
      this.activity.activityName = this.$route.query.activityName;
      this.getTableList();
      this.getProductList();
    },
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    deactivated() {}, //如果页面有keep-alive缓存功能，当组件被移除时，触发钩子函数deactivated
  }
</script>

<style lang='scss' scoped>
  /deep/ .el-dialog__body{
    padding: 20px !important;
  }
</style>



// WEBPACK FOOTER //
// src/page/activityManage/lotteryActivityTaskPrizes/lotteryActivityTaskPrizes.vue